import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDeleteEventSession } from 'actions/eventSessions';
import createLocation from 'utils/createLocation';
import Text from 'components/Text';
import SimpleModal from 'components/SimpleModal';
import Icon from 'components/Icon';
import Stack from 'components/Stack';
import { getFormattedStartDateTime, sessionQueryParameters } from 'screens/EventSessionsManager';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function DeleteSessionModal(_ref) {
  var eventId = _ref.eventId,
    session = _ref.session,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var location = useLocation();
  var navigate = useNavigate();
  var _useDeleteEventSessio = useDeleteEventSession({
      eventId: eventId,
      onSuccess: function onSuccess() {
        var currentSessionId = new URLSearchParams(location.search).get(sessionQueryParameters.id);
        if (currentSessionId === String(session.id)) {
          navigate(createLocation(location, _defineProperty({}, sessionQueryParameters.id, undefined)), {
            replace: true
          });
        }
        onClose();
      }
    }),
    deleteSession = _useDeleteEventSessio.deleteSession,
    isDeleting = _useDeleteEventSessio.isPending;
  var formattedDateTime = getFormattedStartDateTime({
    timezone: session.timezone,
    startDateTime: session.startDateTime
  });
  return /*#__PURE__*/_jsx(SimpleModal, {
    title: t('modal_delete_session_title'),
    body: /*#__PURE__*/_jsxs(Stack, {
      spacing: "s",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "p",
        children: t('modal_delete_session_message')
      }), /*#__PURE__*/_jsxs(Stack, {
        spacing: "xxs",
        children: [/*#__PURE__*/_jsxs(Text, {
          children: [/*#__PURE__*/_jsx(Icon, {
            vAlign: true,
            name: "asset-event",
            mr: "xs"
          }), formattedDateTime]
        }), session.reference && /*#__PURE__*/_jsx(Text, {
          dimmed: true,
          size: "xs",
          children: session.reference
        })]
      })]
    }),
    buttons: [{
      label: t('actions_keep'),
      onClick: onClose
    }, {
      label: t('actions_delete'),
      onClick: function () {
        var _onClick = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var _t;
          return _regeneratorRuntime.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 1;
                return deleteSession({
                  sessionId: session.id
                });
              case 1:
                _context.next = 3;
                break;
              case 2:
                _context.prev = 2;
                _t = _context["catch"](0);
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[0, 2]]);
        }));
        function onClick() {
          return _onClick.apply(this, arguments);
        }
        return onClick;
      }(),
      variant: 'important',
      isLoading: isDeleting
    }],
    onClose: onClose
  });
}
export default DeleteSessionModal;